// Ijara2.js
// This file clones Ijara.js logic but applies Transport.js design & perPage handling

import React, {useEffect, useState} from 'react';
import {
    Button,
    Col,
    Container,
    Form,
    Modal,
    Row,
    Table,
    Spinner,
    InputGroup,
    FormControl,
    Card, Pagination,
} from 'react-bootstrap';
import {FaEdit, FaEye, FaPlus, FaTrash, FaSearch} from 'react-icons/fa';
import IjaraService from '../../services/IjaraService';
import TransportService from '../../services/TransportService';
import FaylService from '../../services/FaylService';
import ConfirmModal from ".././ConfirmModal";
import IjaraAdd from ".././IjaraAdd";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ShowIjara = ({ transportId }) => {
    const [rentals, setRentals] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [expiryFilter, setExpiryFilter] = useState('0');
    const [loading, setLoading] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const [formData, setFormData] = useState({
        transportNumber: '',
        transport_id: '',
        raqam: '',
        dan: '',
        gacha: '',
        izoh: '',
        fayl: null,
        id: '',
    });

    const [transportList, setTransportList] = useState([]);
    const [filteredTransports, setFilteredTransports] = useState([]);
    const [showCombo, setShowCombo] = useState(false);
    const today = new Date();

    const perPageOptions = [5, 10, 20, 50, 100];

    const getDayDifference = (expiryDate) => {
        const diff = Math.ceil((new Date(expiryDate) - today) / (1000 * 60 * 60 * 24));
        return diff;
    };

    const getColorClass = (daysLeft) => {
        if (daysLeft < 0) return 'text-danger fw-bold';
        if (daysLeft < 7) return 'text-warning fw-bold';
        return 'text-success fw-bold';
    };

    const fetchIjaraData = async () => {
        setLoading(true);
        try {
            const search = searchTerm.toLowerCase();
            const res = await IjaraService.getIjaraListByFilter(currentPage, perPage, search, sortOrder, expiryFilter, transportId, 0);
            setRentals(res.data.data);
            setTotalItems(res.data.total);
            setTotalPages(Math.ceil(res.data.total / perPage));
        } catch (err) {
            toast.error('Malumotlarni yuklashda xatolik yuz berdi');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchIjaraData();
    }, [currentPage, perPage, searchTerm, sortOrder, expiryFilter]);

    useEffect(() => {
        const fetchTransports = async () => {
            const resp = await TransportService.getTransportList();
            setTransportList(resp.data);
        };
        fetchTransports();
    }, []);

    const handleTransportInput = (e) => {
        const val = e.target.value;
        setFormData({...formData, transportNumber: val});
        const filtered = transportList.filter(t =>
            t.davlat_raqam.toLowerCase().includes(val.toLowerCase())
        );
        setFilteredTransports(filtered);
        setShowCombo(true);
    };

    const selectTransport = (val, id) => {
        setFormData({...formData, transportNumber: val, transport_id: id});
        setShowCombo(false);
    };

    const handleGetFile = async (item) => {
        const path = FaylService.getFaylPath(item.fayl);
        window.open(path, '_blank');
    };

    const handleAddClick = () => {
        setSelectedItem(null);
        setFormData({transportNumber: '', transport_id: '', raqam: '', dan: '', gacha: '', izoh: '', fayl: null});
        setShowModal(true);
    };

    const handleEditClick = (item) => {
        setSelectedItem(item);
        setFormData({
            transportNumber: item.transport.davlat_raqam,
            transport_id: item.transport.id,
            raqam: item.raqam,
            dan: item.dan,
            gacha: item.gacha,
            izoh: item.izoh,
            fayl: item.fayl,
            id: item.id
        });
        setShowModal(true);
    };

    const confirmDelete = async () => {
        try {
            await IjaraService.deleteIjara(itemToDelete.id);
            toast.success("Ijara muvaffaqiyatli o‘chirildi!");
            fetchIjaraData();
        } catch {
            toast.error("Xatolik yuz berdi!");
        } finally {
            setShowConfirmModal(false);
            setItemToDelete(null);
        }
    };

    const handleEditSave = async () => {
        try {
            if (!formData.transportNumber || !formData.raqam || !formData.dan || !formData.gacha) {
                toast.error("Iltimos, barcha majburiy maydonlarni to'ldiring!", {
                    position: "bottom-right",
                    autoClose: 3000,
                });
                return;
            }
            const data = new FormData();
            data.append('id', formData.id);
            data.append('transport_id', formData.transport_id);
            data.append('raqam', formData.raqam);
            data.append('dan', formData.dan);
            data.append('gacha', formData.gacha);
            data.append('izoh', formData.izoh || '');
            if (formData.fayl) {
                data.append('fayl', formData.fayl); // Fayl mavjud bo‘lsa
            }
            await IjaraService.updateIjara(data, formData.id);
            toast.success("Ijara muvaffaqiyatli o'zgartirildi!", {
                position: "bottom-right",
                autoClose: 3000,
            });
            setShowModal(false);
            await fetchIjaraData();
        } catch (e) {
            console.log(e);
        }
    }
    const handleAddSave = async () => {
        try {
            if (!formData.transportNumber || !formData.raqam || !formData.dan || !formData.gacha) {
                toast.error("Iltimos, barcha majburiy maydonlarni to'ldiring!", {
                    position: "bottom-right",
                    autoClose: 3000,
                });
                return;
            }
            const data = new FormData();
            data.append('id', formData.id);
            data.append('transport_id', formData.transport_id);
            data.append('raqam', formData.raqam);
            data.append('dan', formData.dan);
            data.append('gacha', formData.gacha);
            data.append('izoh', formData.izoh || '');
            if (formData.fayl) {
                data.append('fayl', formData.fayl); // Fayl mavjud bo‘lsa
            }
            await IjaraService.addIjara(data);
            toast.success("Ijara muvaffaqiyatli qo'shildi!", {
                position: "bottom-right",
                autoClose: 3000,
            });
            setShowModal(false);
            await fetchIjaraData();

        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Container fluid className="py-4">
            <Card className="mb-4">
                {/*<Card.Header className="d-flex justify-content-between align-items-center">*/}
                {/*    <h5 className="mb-0">Ijaralar ro'yxati</h5>*/}
                {/*    <Button variant="primary" onClick={handleAddClick}><FaPlus className="me-2"/> Qo‘shish</Button>*/}
                {/*</Card.Header>*/}
                <Card.Body>
                    <Form className="mb-4">
                        <Row>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tartiblash</Form.Label>
                                    <Form.Select value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
                                        <option value="asc">Tugash muddati (kamdan ko‘pga)</option>
                                        <option value="desc">Tugash muddati (ko‘pdan kamga)</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Muddati</Form.Label>
                                    <Form.Select value={expiryFilter} onChange={e => setExpiryFilter(e.target.value)}>
                                        <option value="0">Hammasi</option>
                                        <option value="-1">Muddati o‘tganlar</option>
                                        <option value="7">7 kun ichida tugaydiganlar</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Qidiruv</Form.Label>
                                    <InputGroup>
                                        <FormControl
                                            placeholder="Qidirish: raqam, mashina, izoh..."
                                            value={searchTerm}
                                            onChange={e => setSearchTerm(e.target.value)}
                                        />
                                        <Button variant="outline-secondary"><FaSearch/></Button>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>

                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Mashina raqam</th>
                                <th>Ijara raqami</th>
                                <th>Muddati</th>
                                <th>Kun farqi</th>
                                <th>Izoh</th>
                                <th>Amallar</th>
                            </tr>
                            </thead>
                            <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="7" className="text-center"><Spinner animation="border"/></td>
                                </tr>
                            ) : rentals.length === 0 ? (
                                <tr>
                                    <td colSpan="7" className="text-center">Ma'lumot topilmadi</td>
                                </tr>
                            ) : (
                                rentals.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                                        <td>{item.transport.davlat_raqam}</td>
                                        <td>{item.raqam}</td>
                                        <td>{item.gacha}</td>
                                        <td className={getColorClass(getDayDifference(item.gacha))}>{getDayDifference(item.gacha)}</td>
                                        <td>{item.izoh}</td>
                                        <td>
                                            <div className="d-flex">
                                                {/*<Button variant="link" size="sm" className="text-warning me-2 p-0"*/}
                                                {/*        onClick={() => handleEditClick(item)}><FaEdit/></Button>*/}
                                                {/*<Button variant="link" size="sm" className="text-danger me-2 p-0"*/}
                                                {/*        onClick={() => {*/}
                                                {/*            setItemToDelete(item);*/}
                                                {/*            setShowConfirmModal(true);*/}
                                                {/*        }}><FaTrash/></Button>*/}
                                                <Button variant="link" size="md" className="text-info p-0"
                                                        onClick={() => handleGetFile(item)}><FaEye/></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </Table>
                    </div>

                    {/*<div className="d-flex justify-content-between align-items-center mt-3">*/}
                    {/*    <div className="d-flex align-items-center">*/}
                    {/*        <span className="me-2">Har sahifada:</span>*/}
                    {/*        <Form.Select style={{ width: '80px' }} value={perPage} onChange={(e) => { setPerPage(parseInt(e.target.value)); setCurrentPage(1); }}>*/}
                    {/*            {perPageOptions.map(option => (*/}
                    {/*                <option key={option} value={option}>{option}</option>*/}
                    {/*            ))}*/}
                    {/*        </Form.Select>*/}
                    {/*        <span className="ms-2">Jami: {totalItems} ta</span>*/}
                    {/*    </div>*/}
                    {/*    <div>*/}
                    {/*        <Pagination className="mb-0">*/}
                    {/*            {[...Array(totalPages)].map((_, i) => (*/}
                    {/*                <Pagination.Item key={i} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>*/}
                    {/*            ))}*/}
                    {/*        </Pagination>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <div className="d-flex align-items-center">
                            <span className="me-2">Har sahifada:</span>
                            <Form.Select
                                style={{width: '80px'}}
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(parseInt(e.target.value));
                                    setCurrentPage(1);
                                }}
                                disabled={loading}
                            >
                                {perPageOptions.map(option => (
                                    <option key={option} value={option}>{option}</option>
                                ))}
                            </Form.Select>
                            <span className="ms-2">{loading ? 'Yuklanmoqda...' : `Jami: ${totalItems} ta`}</span>
                        </div>
                        {Math.ceil(totalItems / perPage) > 1 && (
                            <Pagination className="mb-0">
                                <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1}/>
                                {[...Array(Math.ceil(totalItems / perPage))].map((_, i) => (
                                    <Pagination.Item
                                        key={i}
                                        active={i + 1 === currentPage}
                                        onClick={() => setCurrentPage(i + 1)}
                                    >
                                        {i + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Last onClick={() => setCurrentPage(Math.ceil(totalItems / perPage))}
                                                 disabled={currentPage === Math.ceil(totalItems / perPage)}/>
                            </Pagination>
                        )}
                    </div>
                </Card.Body>
            </Card>

            <IjaraAdd
                showModal={showModal}
                onHide={() => setShowModal(false)}
                setShowModal={setShowModal}
                selectedItem={selectedItem}
                formData={formData}
                setFormData={setFormData}
                handleTransportInput={handleTransportInput}
                selectTransport={selectTransport}
                filteredTransports={filteredTransports}
                handleEditSave={handleEditSave}
                handleAddSave={handleAddSave}
                setShowCombo={setShowCombo}
                showCombo={showCombo}
            />

            {/*<ToastContainer/>*/}

            <ConfirmModal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                onConfirm={confirmDelete}
                title="Ijarani o‘chirish"
                message={`Rostan ham \"${itemToDelete?.raqam}\" raqamli ijarani o‘chirmoqchimisiz?`}
            />
        </Container>
    );
};

export default ShowIjara;
